import { ErrorBoundary } from '@components/error_boundary.component';
import { withTranslation } from '@modules/i18n_and_l10n/with_translation';
import { useTitle } from '@src/application/use_title';
import { lazy, Suspense } from 'react';

interface Props {}

const Inner = lazy(() => import('./_inner.component').then((module) => ({ default: module['Inner'] })));

export function ChangeUnit(_: Props): JSX.Element {
	useTitle(withTranslation('PW.Component.ChangeUnit.Title'));

	return (
		<ErrorBoundary>
			<Suspense fallback={null}>
				<Inner />
			</Suspense>
		</ErrorBoundary>
	);
}
